import {Injectable} from "@angular/core";
import {NewRelicService} from "./newrelic.service";
import {WindowRef} from "./window-ref";
import {Location} from "@angular/common";

@Injectable()
export class ErrorLogService {

    constructor(private newrelic: NewRelicService, private location:Location){}

    public logError( error: any ) : void {
        this.sendToConsole( error );
        this.sendToNewRelic( error );
    }

    // I send the error the browser console (safely, if it exists).
    private sendToConsole(error: any): void {
        try{
            if ( console && console.group ) {
                console.group("Error Log Service");
                console.log(error);
                console.groupEnd();
            }
        } catch ( handlingError ) {
            console.group( "ErrorHandler" );
            console.warn( "Error when trying to output error." );
            console.log( handlingError );
            console.groupEnd();
        }
    }

    // I send the error to the NewRelic error logging service.
    private sendToNewRelic( error: any ) : void {
        this.newrelic.noticeError( error );
    }

    public goToInternalError():void{
        this.location.go('internal-error');
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/core/error-log.service.ts